import { schoolCreateURL } from './schoolCreateURL';
import { schoolSearchURL } from './schoolSearchURL';

const request = require('../../../../../shared/Request');

export function searchForSchool({
  terms,
  onSuccess,
  onError,
}: {
  terms: string;
  onSuccess: (data) => any;
  onError: (data) => any;
}) {
  const url = schoolSearchURL({ terms });
  request.post({
    url: url.href,
    data: {},
    success: onSuccess,
    error: onError,
  });
}

export async function createSchool({
  city,
  state,
  country,
  zip_code,
  school_name,
  description,
  onSuccess,
  onError,
}: {
  city: string;
  state: string;
  country: string;
  school_name: string;
  description: string;
  zip_code: string;
  onSuccess: (data) => any;
  onError: (data) => any;
}) {
  const url = schoolCreateURL();
  request.post({
    url: url.href,
    data: {
      city: city,
      state: state,
      country: country,
      school_name: school_name,
      zip_code: zip_code,
      description: description,
    },
    success: onSuccess,
    error: onError,
  });
}
